import { useCallback } from 'react'
import { useLocale } from '../locale/useLocale'
import { useFormat } from './useFormat'

export const useFormatDateShort = () => {
  const locale = useLocale()
  const format = useFormat()
  return useCallback(
    (date: Date) => {
      const formatStr = locale === 'de' ? 'dd.MM.yyyy' : 'MM-dd-yyyy'
      return format(date, formatStr)
    },
    [locale, format]
  )
}
